/* eslint-disable @typescript-eslint/no-unused-expressions */
import React, { useEffect, useState } from "react";
import {
  CustomPropertyInputItem,
  CustomPropertySelect,
} from "ui/CustomProperty";
import { CPSelectTypeProps } from "../types";
import { SelectOptionType } from "../../select/Select";
import { useFormContext } from "react-hook-form";

const SelectCustomProp: React.FC<CPSelectTypeProps> = ({
  keyId,
  name,
  required,
  readOnly,
  changeable,
  permissions,
  codeName,
  tabIndex,
  isWidget,
  defaultValue,
  parentKey,
  values,
  onChange,
  isError
}) => {
  const methods = useFormContext();
  const [option, setOption] = useState<SelectOptionType[]>([]);
  const [allOptions, setAllOptions] = useState<SelectOptionType[]>([]);
  const [valid, setValid] = useState(true);
  const [value, setValue] = useState<SelectOptionType | null>(null);

  useEffect(() => {
	if (isError !== undefined && required) {
	  setValid(!isError);
	}
  }, [isError]);

  const validate = (checkedValue: SelectOptionType | null): boolean => {
    const isValid = !required || (!!checkedValue && checkedValue.value !== 0);
    setValid(isValid);
    return isValid;
  };

  const handleChange = async (selectedOption: SelectOptionType) => {
    validate(selectedOption);
    setValue({ ...selectedOption, key: keyId, parentKey: parentKey });
    const index = methods
      .getValues()
      ?.customFields?.findIndex((item: any) => item.key === keyId);
    methods.setValue(`customFields.${index}.value`, selectedOption.value);
    onChange({ ...selectedOption, key: keyId, parentKey: parentKey });
  };

  const getSelectValue = () => {
    setAllOptions(values);
    validate(defaultValue);
    setValue(defaultValue);
  };

  useEffect(() => {
    if (allOptions?.length > 20 && value) {
      setOption([
        ...allOptions?.filter((item) => item.text.includes(value.text)),
      ]);
    }
  }, [value, allOptions]);

  useEffect(() => {
    getSelectValue();
  }, [values]);

  const isDisabled =
    (isWidget && !changeable) ||
    !permissions.includes(`CustomProperty_${codeName}`);

  return (
    <CustomPropertyInputItem
      isWidget={!!isWidget}
      valid={valid}
      name={name}
      required={required}
      disabled={isDisabled}
      keyId={keyId}
    >
      <CustomPropertySelect
        isWidget={!!isWidget}
        name={name}
        keyId={keyId}
        options={allOptions.length > 20 ? option : allOptions}
        handleChange={handleChange}
        defaultValue={value || defaultValue || null}
        defaultText={value?.text || defaultValue?.text || ""}
        readOnly={readOnly}
        autocomplete={allOptions.length > 20}
        disabled={isDisabled}
        tabIndex={tabIndex}
      />
    </CustomPropertyInputItem>
  );
};

export default SelectCustomProp;
